import { Phone } from "lucide-react";
import { SUPPORT_PHONE, SUPPORT_PHONE_TEL } from "@/constants/company";
import { trackCtaClick } from "@/analytics";
import { cn } from "@/lib/utils";

type SupportPhoneLinkProps = {
  className?: string;
  iconClassName?: string;
  trackName?: string;
  showIcon?: boolean;
  onClick?: () => void;
};

export default function SupportPhoneLink({
  className,
  iconClassName,
  trackName,
  showIcon = true,
  onClick,
}: SupportPhoneLinkProps) {
  return (
    <a
      href={SUPPORT_PHONE_TEL}
      className={cn("inline-flex items-center gap-1.5", className)}
      aria-label={`Call ${SUPPORT_PHONE}`}
      onClick={() => {
        if (trackName) trackCtaClick(trackName);
        onClick?.();
      }}
    >
      {showIcon && <Phone className={cn("h-4 w-4 shrink-0", iconClassName)} aria-hidden />}
      {SUPPORT_PHONE}
    </a>
  );
}
